<template>
    <div >
        <div v-if="delete_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="table-content mb-3" style="overflow-x: auto !important;">
            <table class="table table-content-data table-responsive" style="border: solid 0.5px #f2f3f5;border-radius: 8px;">
                <thead>
                    <tr>
                        <th class="whiteSpace w-1">
                            Employee Name
                        </th>
                        <th class="whiteSpace w-1">
                            Department
                        </th>
                        <th class="whiteSpace w-1">
                            Work Shift
                        </th>
                        <th class="whiteSpace w-1">
                            Start Time
                        </th>
                        <th class="whiteSpace w-1">
                            End Time
                        </th>
                        <th class="whiteSpace w-1">
                            Working <br>Hours
                        </th>
                        <th class="whiteSpace w-1">
                            
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold">
                        <td colspan="7">
                            <div class="position-relative">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center font-weight-bold ht-100px">
                        <td colspan="7">No Data Found</td>
                    </tr>
                    <tr v-else v-for="(data, index) in list_data" :key="index+'djdj'">
                        <td class="whiteSpace w-1">
                            {{data.employee_name || "-"}}
                        </td>
                        <td class="whiteSpace w-1">
                            {{data.department_name || "-"}}
                        </td>
                        <td class="whiteSpace w-1">
                            {{data.work_shift || "-"}}
                        </td>
                        <td v-if="data.start_time" class="whiteSpace w-1 ">
                            {{convertTime24To12(data.start_time)}}
                        </td>
                        <td v-else class="whiteSpace w-1 ">
                            -
                        </td>
                        <td v-if="data.end_time" class="whiteSpace w-1 ">
                            {{convertTime24To12(data.end_time)}}
                        </td>
                        <td v-else class="whiteSpace w-1 ">
                            -
                        </td>
                        <td class="whiteSpace w-1">
                            {{data.working_hours || "-"}}
                        </td>
                        <td class="whiteSpace w-1">
                            <span class="pointer whiteSpace buttons action-btns-show-hide">
                                <button class="btn btn-icon actionicons view" style="height: 25px;padding: 5px !important;" @click="showEditModal(data._id)" >
                                    <el-tooltip class="item" effect="dark" content="Edit" style="bottom: 4.5px;" placement="top">
                                        <i class="icon icon-pencil editIcon"></i>
                                    </el-tooltip>
                                </button>
                                <button class="btn btn-icon actionicons update ml-3" style="height: 25px;padding: 5px !important;" @click="deleteEmployee(data._id)">
                                    <el-tooltip class="item" effect="dark" content="Delete" style="bottom: 4.5px;" placement="top">
                                        <i class="icon icon-trash deleteIcon"></i>
                                    </el-tooltip>
                                </button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <create-configure-shift-employee v-if="create_modal" @saveSuccess="saveSuccess" @hideModal="hideCreateModal" :employee_shift_id="employee_shift_id" :mode="mode" modal_name="Create-Modal"></create-configure-shift-employee>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { EventBus } from '../../eventBus/nav-bar-event';
import facility_mgmt from '../../mixins/facility_mgmt';
const CreateConfigureShiftEmployee = () => import('./CreateConfigureShiftEmployee');
import { SweetModal } from 'sweet-modal-vue';
import time_utils from '../../mixins/time_utils';
export default {
    mixins: [facility_mgmt, time_utils],
    props: ['passed_list_data'],
    components: { 
        CreateConfigureShiftEmployee,
        SweetModal
    },
    data(){
        return{
            delete_loader: false,
            success_msg: '',
            warning_msg: '',
            create_modal: '',
            employee_shift_id: '',
            mode: '',
            list_data: []
        }
    },
    methods:{
        saveSuccess() {
            this.$emit('createEmpSuccess');
        },
        hideCreateModal() {
            this.create_modal = false;
            setTimeout(() => {
                this.$modal.hide('Create-Modal');
            }, 500);
        },
        showCreateModal() {
            this.mode = 'create';
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        showEditModal(id) {
            this.mode = 'edit';
            this.employee_shift_id = id;
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        async deleteEmployee(id) {
            this.delete_loader = true
            try {
                let params = {
                    employee_shift_id: id,
                };
                let response = await this.deleteEmployeeShiftById(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.delete_loader = false
                    this.$emit('createEmpSuccess');
                }, 3000);
            }
            catch (error) {
                this.delete_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
    },
    mounted() {
        this.list_data = this.passed_list_data;
        EventBus.$on('addEmployee', () => {
            this.showCreateModal();
        });
    },
    watch: {
        
    },
}
</script>
<style scoped>
    .ht-100px{
        height: 100px;
    }
</style>